<template>
  <div id="app">
    <NavBar />
    <Stage :stageName="$route.params.name" :eventName="$route.params.eventName" />
    <Footer />
  </div>
</template>

<script>

import NavBar from "./components/NavBar.vue";
import Footer from "./components/Footer.vue";
import Stage from "./components/Stage.vue";

export default {
  name: "StagePage",
  components: {
    NavBar,
    Footer,
    Stage
  }

};
</script>

<style scoped>
@import "./components/webflow.css";
@import "./components/normalize.css";
@import "./components/sffnotes.webflow.css";
</style>
